import './dailyForm.scss';

import { format } from 'date-fns';
import * as React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { actions } from 'react-redux-form';
import { withRouter } from 'react-router';
import { IHistory } from 'src/interfaces';

import { submitDailyForm, getDailyFormDetails } from '../../../services/dailyFormService';
import { dispatch, marshallAnswers, getPageTitle } from '../../../utils/generalUtils';
import { BasePage } from '../../reusableComponents/BasePage';
import { Form } from '../../reusableComponents/FormComponents/Form';
import { FormFooter } from '../../reusableComponents/FormComponents/FormFooter';
import { InputRow } from '../../reusableComponents/FormComponents/InputRow';
import { QuestionRow } from '../../reusableComponents/FormComponents/QuestionRow';
import { ImageUpload } from '../../reusableComponents/ImageUpload';
import { Async } from '../../reusableComponents/Async';
import { Loader } from '../../reusableComponents/Loader';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { getFormDetails } from '../../../services/dashboardService';
import { DailyFormsModel } from '../../../model/DailyFormModel';
import { questionData } from '../../../constants/generals';
import { CreateForm } from './CreateForm';

export interface IDailyFormProps extends DispatchProp<any> {
    date: string;
    plantId: string;
    formId: string;
    userUID: string;
    history: IHistory;
    formInstance: DailyFormsModel;
    form;
}

export interface IDailyFormState {
    date: string;
}

export class DailyFormImpl extends React.Component<IDailyFormProps, IDailyFormState> {
    constructor(props: IDailyFormProps) {
        super(props);
        this.state = {
            date: props.date,
        };
    }

    static defaultProps: IDailyFormProps;

    identifier = 'DailyForm';

    refs: {
        images: CreateForm;
    };

    handleSubmit = async (values) => {  
        const answer = marshallAnswers(values);
        const data = {
            UserId: this.props.userUID,
            PlantId: this.props.plantId,
            InspectionID: 'DailyForm',
            followUp_Required: false,
            Completed: true,
            Date: format(new Date(this.props.date), 'MM-DD-YYYY'),
            Answers: answer,
            ImageUrls: [],
            DeletedImages : this.props.form.dailyForm.deletedImages || [],
            followUp_form: 0,
            SignatureUrls: [],
            AssociatedTo: null
        };
        return submitDailyForm(data, this.props.history, this.refs.images.value, this.props.formId);
    }

    renderContent = () => {
        return <div className="daily-form">
            <CreateForm
                ref="images"
                loadDefaultValues={this.populateValues}
                handleSubmit={this.handleSubmit}
                state={this.state}
                instance={this.props.formInstance}
                formId={this.props.formId}
            />
        </div>;
    }

    promise = async () => {
        await getDailyFormDetails(this.props.formId);
    }

    populateValues = () => {
        const { formInstance } = this.props;
        if (formInstance) {
            const { props: { questions } } = formInstance;
            questions.forEach((questions) => {
                dispatch(actions.change(`forms.dailyForm.${questions.quesNum}`, questions.answer));
            });
        }
    }

    renderForm = () => {
        const { formId } = this.props;
        if (formId) {
            return <Async
                identifier={this.identifier}
                promise={this.promise}
                loader={<Loader type="async" />}
                error={<ErrorPage />}
                content={this.renderContent()}
            />;
        }
        return this.renderContent();
    }

    render() {
        let title = `${getPageTitle('DailyForm', 'daily', this.props.date, 'inspection')} `;
        return < BasePage
            pageTitle={ title /* `Daily Inspection for ${format((this.props.date.replace(/\-/g, '/')), 'MM/DD/YYYY')}` */} >
            {this.renderForm()}
        </BasePage>;
    }
}
export function mapStateToProps(state, ownProps) {
    const formInstance = DailyFormsModel.get(ownProps.match.params.formId); 
    return {
        date: ownProps.match.params.date,
        plantId: ownProps.match.params.plantId,
        formId: ownProps.match.params.formId,
        userUID: state.login.get('UniqueId'),
        formInstance,
        form: state.forms,
    };
}
export const DailyForm = withRouter(connect<{}, {}, IDailyFormProps>(mapStateToProps)(DailyFormImpl));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Forms/DailyForm/index.tsx